const DataURLtoFile = (dataurl, filename) => {
  try {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    if (!document.documentMode && !/Edge/.test(navigator.userAgent)) {
      try {
        return new File([u8arr], filename, { type: mime })
      } catch (err) {
        console.error(err)
        return new Blob([u8arr], { type: mime })
      }
    } else if (typeof window.navigator.msSaveBlob !== 'undefined') {
      return new Blob([u8arr], { type: mime })
    }
  } catch (err) {
    console.error(err)
    return null
  }
}

export default DataURLtoFile
